module.exports = __webpack_public_path__ + "img/wifi-weak.8fda2a94.svg";